// package: analyticsmanager
// file: analytics-manager.proto

var analytics_manager_pb = require("./analytics-manager_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var AnalyticsManager = (function () {
  function AnalyticsManager() {}
  AnalyticsManager.serviceName = "analyticsmanager.AnalyticsManager";
  return AnalyticsManager;
}());

AnalyticsManager.ListTrades = {
  methodName: "ListTrades",
  service: AnalyticsManager,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.ListTradesReq,
  responseType: analytics_manager_pb.ListTradesReply
};

AnalyticsManager.GetBalanceInfo = {
  methodName: "GetBalanceInfo",
  service: AnalyticsManager,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.GetBalanceInfoReq,
  responseType: analytics_manager_pb.GetBalanceInfoReply
};

AnalyticsManager.AccountStats = {
  methodName: "AccountStats",
  service: AnalyticsManager,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.AccountStatsReq,
  responseType: analytics_manager_pb.AccountStatsReply
};

AnalyticsManager.CopierMetrics = {
  methodName: "CopierMetrics",
  service: AnalyticsManager,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.CopierMetricsReq,
  responseType: analytics_manager_pb.CopierMetricsReply
};

AnalyticsManager.OverviewStats = {
  methodName: "OverviewStats",
  service: AnalyticsManager,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.OverviewStatsReq,
  responseType: analytics_manager_pb.OverviewStatsReply
};

AnalyticsManager.ListAccountStats = {
  methodName: "ListAccountStats",
  service: AnalyticsManager,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.ListAccountStatsReq,
  responseType: analytics_manager_pb.ListAccountStatsReply
};

AnalyticsManager.AccountsOverviewStats = {
  methodName: "AccountsOverviewStats",
  service: AnalyticsManager,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.AccountsOverviewStatsReq,
  responseType: analytics_manager_pb.AccountsOverviewStatsReply
};

AnalyticsManager.AdminGetAccountBalance = {
  methodName: "AdminGetAccountBalance",
  service: AnalyticsManager,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.AdminGetAccountBalanceReq,
  responseType: analytics_manager_pb.AdminGetAccountBalanceReply
};

AnalyticsManager.AdminListTrades = {
  methodName: "AdminListTrades",
  service: AnalyticsManager,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.AdminListTradesReq,
  responseType: analytics_manager_pb.AdminListTradesReply
};

AnalyticsManager.AdminSyncAccount = {
  methodName: "AdminSyncAccount",
  service: AnalyticsManager,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.AdminSyncAccountReq,
  responseType: analytics_manager_pb.AdminSyncAccountReply
};

exports.AnalyticsManager = AnalyticsManager;

function AnalyticsManagerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

AnalyticsManagerClient.prototype.listTrades = function listTrades(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AnalyticsManager.ListTrades, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyticsManagerClient.prototype.getBalanceInfo = function getBalanceInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AnalyticsManager.GetBalanceInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyticsManagerClient.prototype.accountStats = function accountStats(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AnalyticsManager.AccountStats, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyticsManagerClient.prototype.copierMetrics = function copierMetrics(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AnalyticsManager.CopierMetrics, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyticsManagerClient.prototype.overviewStats = function overviewStats(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AnalyticsManager.OverviewStats, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyticsManagerClient.prototype.listAccountStats = function listAccountStats(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AnalyticsManager.ListAccountStats, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyticsManagerClient.prototype.accountsOverviewStats = function accountsOverviewStats(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AnalyticsManager.AccountsOverviewStats, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyticsManagerClient.prototype.adminGetAccountBalance = function adminGetAccountBalance(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AnalyticsManager.AdminGetAccountBalance, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyticsManagerClient.prototype.adminListTrades = function adminListTrades(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AnalyticsManager.AdminListTrades, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AnalyticsManagerClient.prototype.adminSyncAccount = function adminSyncAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AnalyticsManager.AdminSyncAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.AnalyticsManagerClient = AnalyticsManagerClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "analyticsmanager.Internal";
  return Internal;
}());

Internal.IntAddAnalyticsUser = {
  methodName: "IntAddAnalyticsUser",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.IntAddAnalyticsUserReq,
  responseType: analytics_manager_pb.IntAddAnalyticsUserReply
};

Internal.IntGetMasterTrades = {
  methodName: "IntGetMasterTrades",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.IntGetMasterTradesReq,
  responseType: analytics_manager_pb.IntGetMasterTradesReply
};

Internal.IntGetOpenTradeTickets = {
  methodName: "IntGetOpenTradeTickets",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.IntGetOpenTradeTicketsReq,
  responseType: analytics_manager_pb.IntGetOpenTradeTicketsReply
};

Internal.IntGetTradeDetails = {
  methodName: "IntGetTradeDetails",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.IntGetTradeDetailsReq,
  responseType: analytics_manager_pb.IntGetTradeDetailsReply
};

Internal.IntGetTradeAccountStats = {
  methodName: "IntGetTradeAccountStats",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.IntGetTradeAccountStatsReq,
  responseType: analytics_manager_pb.IntGetTradeAccountStatsReply
};

Internal.IntUpdateConsiderAccountOnPortfolio = {
  methodName: "IntUpdateConsiderAccountOnPortfolio",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.IntUpdateConsiderAccountOnPortfolioReq,
  responseType: analytics_manager_pb.IntUpdateConsiderAccountOnPortfolioReply
};

Internal.IntGetConsiderAccountOnPortfolio = {
  methodName: "IntGetConsiderAccountOnPortfolio",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.IntGetConsiderAccountOnPortfolioReq,
  responseType: analytics_manager_pb.IntGetConsiderAccountOnPortfolioReply
};

Internal.IntGetUserOpenTradesCount = {
  methodName: "IntGetUserOpenTradesCount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.IntGetUserOpenTradesCountReq,
  responseType: analytics_manager_pb.IntGetUserOpenTradesCountReply
};

Internal.IntGetTotalOpenTradesCount = {
  methodName: "IntGetTotalOpenTradesCount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: analytics_manager_pb.IntGetTotalOpenTradesCountReq,
  responseType: analytics_manager_pb.IntGetTotalOpenTradesCountReply
};

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalClient.prototype.intAddAnalyticsUser = function intAddAnalyticsUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntAddAnalyticsUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetMasterTrades = function intGetMasterTrades(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetMasterTrades, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetOpenTradeTickets = function intGetOpenTradeTickets(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetOpenTradeTickets, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetTradeDetails = function intGetTradeDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetTradeDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetTradeAccountStats = function intGetTradeAccountStats(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetTradeAccountStats, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUpdateConsiderAccountOnPortfolio = function intUpdateConsiderAccountOnPortfolio(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUpdateConsiderAccountOnPortfolio, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetConsiderAccountOnPortfolio = function intGetConsiderAccountOnPortfolio(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetConsiderAccountOnPortfolio, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetUserOpenTradesCount = function intGetUserOpenTradesCount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetUserOpenTradesCount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetTotalOpenTradesCount = function intGetTotalOpenTradesCount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetTotalOpenTradesCount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalClient = InternalClient;

